import { useMemo } from 'react';
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import { RootRouteEnum, WebsiteContentRouteEnum } from '~/router/@types';
import { WebsiteContentTabGroupEnum } from '../@types';
import { TAB_INFO } from '../@constants';

export const useTab = () => {
  const navigate = useNavigate();

  const { tab = WebsiteContentRouteEnum.Flagged } = useParams<{
    tab: WebsiteContentRouteEnum;
  }>();

  const tabGroup = useMemo(
    () =>
      Object.values(TAB_INFO).find((tabItem) => {
        if ('path' in tabItem) return tabItem.path === tab;
        return tabItem.children.some(({ path }) => path === tab);
      })?.key || WebsiteContentTabGroupEnum.Flagged,
    [tab]
  );

  const handleChange = (tab: WebsiteContentRouteEnum) => {
    navigate(`/${RootRouteEnum.WebsiteContent}/${tab}`);
  };

  return {
    currentTabGroup: tabGroup,
    currentTab: tab,
    onChange: handleChange,
  };
};
